<mat-card class="mat-card mat-elevation-z1 customer-relations-card">
    @if (showSummary) {
        <app-customer-relations-summary
            [selectedItem]="selectedItem"
            [canToggle]="canToggle"
            [isExpanded]="isExpanded"
            (toggleExpand)="onToggleExpand()"
        ></app-customer-relations-summary>
    }
    <div [class.mb-10px]="showSummary && showAddCustomerRelationButton && !isInToolbar">
        <app-customer-relations-list
            [isExpanded]="isExpanded"
            [installations]="installations"
            [isSingleInstallationView]="isSingleInstallationView"
            [isBusiness]="isBusiness"
            [formGroup]="formGroup"
            [selectedItemId]="selectedItem?.id"
            (selectInstallation)="onSelectInstallation($event)"
        ></app-customer-relations-list>
    </div>
    @if (showAddCustomerRelationButton && !isInToolbar) {
        <app-add-customer-relation
            [isBusiness]="isBusiness"
            (addCustomerRelation)="onAddCustomerRelation()"
        ></app-add-customer-relation>
    }
</mat-card>
